import { FC } from 'react';
import { useCountDown } from 'ahooks';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

interface FlashSaleCountdownProps {
    leftTime: number;
}

const Countdown: FC<FlashSaleCountdownProps> = ({ leftTime }) => {
    const { useLang } = useGlobal();
    const { t } = useLang('appreciationday');

    const [, formattedRes] = useCountDown({
        leftTime: leftTime,
    });

    const { days, hours, minutes, seconds } = formattedRes;
    const handleCompletion = (val: number) => (val < 10 ? `0${val}` : val);

    return (
        <div className={styled.flashSaleCountdown}>
            <div>
                <span className="time">{handleCompletion(days)}</span>
                <span>{t('days')}</span>
            </div>
            <span className="colon">:</span>
            <div>
                <span className="time">{handleCompletion(hours)}</span>
                <span>{t('hours')}</span>
            </div>
            <span className="colon">:</span>
            <div>
                <span className="time">{handleCompletion(minutes)}</span>
                <span>{t('minutes')}</span>
            </div>
            <span className="colon">:</span>
            <div>
                <span className="time">{handleCompletion(seconds)}</span>
                <span>{t('seconds')}</span>
            </div>
        </div>
    );
};

export default Countdown;
